import { NO_RETURN_POLICY_TEXT } from '../../../component/policyConstants';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { logDOM } from '@testing-library/react';




const ProductInformation = (props) => {
  console.log(props, 'check props information')
  const handleDaySelect = (event) => {
    var dayArr = [...props.addProductData.policies];
    const value = event.target.value
    const index = dayArr.findIndex(day => day === value);
    if (index > -1) {
      dayArr = [...dayArr.slice(0, index), ...dayArr.slice(index + 1)]
    } else {
      dayArr.push(value);
    }
    props.setAddProductData({
      ...props.addProductData,
      policies: dayArr,
    })

  };
  console.log(props, 'check imnages new')
  const cardStyle = {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.05)',
    padding: '30px 40px',
    border: '1px solid #eaeaea',
    marginBottom: '30px'
  };

  const labelStyle = {
    fontSize: '15px'
  };

  const inputStyle = {
    borderRadius: '10px',
    border: '1px solid #dcdfe6',
    fontSize: '16px',
    padding: '12px 15px'
  };

  return (
    <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', paddingBottom: '150px' }}>
      <div className="container pt-4">

        {/* Basic Information Card */}
        <div style={cardStyle}>
          <h5 style={{ marginBottom: '25px', fontWeight: '600', color: '#333' }}>Basic Information</h5>
          <div className="row g-4">
            {props.brandData === '' ? <></> :
              <div className="col-md-6">
                <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>Brand Option <span className="text-danger">*</span></label>
                <div className="d-flex gap-4">
                  <div className="form-check" style={{ fontSize: '16px' }}>
                    <input className="form-check-input" type="radio" name="is_brand" id="brandYes" value="1" checked={props.addProductData?.is_brand === "1"} onChange={(e) => props.setAddProductData({ ...props.addProductData, is_brand: e.currentTarget.value })} style={{ width: '1.2em', height: '1.2em', cursor: 'pointer' }} />
                    <label className="form-check-label ms-2" htmlFor="brandYes" style={{ cursor: 'pointer', marginTop: '2px' }}>Brand</label>
                  </div>
                  <div className="form-check" style={{ fontSize: '16px' }}>
                    <input className="form-check-input" type="radio" name="is_brand" id="brandNo" value="2" checked={props.addProductData?.is_brand === "2"} onChange={(e) => props.setAddProductData({ ...props.addProductData, is_brand: e.currentTarget.value })} style={{ width: '1.2em', height: '1.2em', cursor: 'pointer' }} />
                    <label className="form-check-label ms-2" htmlFor="brandNo" style={{ cursor: 'pointer', marginTop: '2px' }}>Non Brand</label>
                  </div>
                </div>
              </div>
            }
            {props.brandData === '' || props.addProductData?.is_brand !== "1" ? <></> :
              <div className="col-md-6">
                <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>Select Brand <span className="text-danger">*</span></label>
                <Select
                  styles={{
                    control: (base) => ({ ...base, minHeight: 48 }),
                    menuList: (base) => ({ ...base, maxHeight: 200 })
                  }}
                  menuPosition="fixed"
                  options={props.brandData ? (Array.isArray(props.brandData) ? props.brandData : Object.values(props.brandData)).map(item => ({ value: item.brand_id, label: item.brand_name })) : []}
                  value={props.brandData ? (Array.isArray(props.brandData) ? props.brandData : Object.values(props.brandData)).map(item => ({ value: item.brand_id, label: item.brand_name })).find(o => o.value == props.addProductData.brand_id) : null}
                  onChange={(option) => props.setAddProductData({ ...props.addProductData, brand_id: option ? option.value : '' })}
                  placeholder={props.brandData && (Array.isArray(props.brandData) ? props.brandData.length : Object.keys(props.brandData).length) > 0 ? "Select Brand" : "No mapped brands for this category"}
                  noOptionsMessage={() => "No brands mapped for this category"}
                  isClearable
                />
                {props.errors && props.errors.brand_id ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>Brand Name is Required</p> : null}
              </div>
            }

            <div className="col-md-6">
              <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>Product Name <span className="text-danger">*</span></label>
              <input type="text" className="form-control form-control-lg shadow-none" style={inputStyle} onChange={e => props.setAddProductData({ ...props.addProductData, product_name: e.target.value })} />
              {props.errors && props.errors.product_name ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{props.errors.product_name}</p> : null}
            </div>

            <div className="col-md-3">
              <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>Product Weight (g) <span className="text-danger">*</span></label>
              <input type="text" className="form-control form-control-lg shadow-none" style={inputStyle} onChange={e => props.setAddProductData({ ...props.addProductData, weight: e.target.value })} />
              {props.errors && props.errors.weight ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{props.errors.weight}</p> : null}
            </div>
            <div className="col-md-3">
              <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>Product Height (cm) <span className="text-danger">*</span></label>
              <input type="text" className="form-control form-control-lg shadow-none" style={inputStyle} onChange={e => props.setAddProductData({ ...props.addProductData, height: e.target.value })} />
              {props.errors && props.errors.height ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{props.errors.height}</p> : null}
            </div>
            <div className="col-md-3">
              <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>Product Width (cm) <span className="text-danger">*</span></label>
              <input type="text" className="form-control form-control-lg shadow-none" style={inputStyle} onChange={e => props.setAddProductData({ ...props.addProductData, width: e.target.value })} />
              {props.errors && props.errors.width ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{props.errors.width}</p> : null}
            </div>
            <div className="col-md-3">
              <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>Product Length (cm) <span className="text-danger">*</span></label>
              <input type="text" className="form-control form-control-lg shadow-none" style={inputStyle} onChange={e => props.setAddProductData({ ...props.addProductData, length: e.target.value })} />
              {props.errors && props.errors.length ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{props.errors.length}</p> : null}
            </div>
            <div className="col-md-3">
              <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>GST (%) <span className="text-danger">*</span></label>
              <select className="form-select form-select-lg shadow-none" style={{ ...inputStyle, cursor: 'pointer' }} onChange={e => props.setAddProductData({ ...props.addProductData, gst: e.target.value })}>
                <option defaultValue> Select GST</option>
                <option value="0">0%</option>
                <option value="5">5%</option>
                <option value="12">12%</option>
                <option value="18">18%</option>
                <option value="28">28%</option>
              </select>
              {props.errors && props.errors.gst ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{props.errors.gst}</p> : null}
            </div>

            <div className="col-md-9">
              <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>
                Pickup / Shipping Address <span className="text-danger">*</span>
              </label>
              <select
                className={`form-select form-select-lg shadow-none ${props.errors && props.errors.pickup_address_id ? 'is-invalid' : ''}`}
                style={{
                  ...inputStyle,
                  cursor: 'pointer',
                  borderColor: props.errors && props.errors.pickup_address_id ? '#dc3545' : '#dcdfe6'
                }}
                value={props.addProductData.pickup_address_id || ''}
                onChange={(e) => {
                  props.setAddProductData({ ...props.addProductData, pickup_address_id: e.target.value });
                  if (props.setErrors && props.errors && props.errors.pickup_address_id) {
                    props.setErrors({ ...props.errors, pickup_address_id: null });
                  }
                }}
              >
                <option value="">Select Pickup Address (Where product belongs / ships from)</option>
                {props.pickupAddressList && props.pickupAddressList.length > 0 ? (
                  props.pickupAddressList.map((addr, idx) => (
                    <option key={idx} value={addr.id}>
                      {addr.name} - {addr.address}, {addr.city}, {addr.pin_code} {addr.pickup_code ? `(${addr.pickup_code})` : ''}
                    </option>
                  ))
                ) : null}
              </select>
              <div className="d-flex justify-content-between align-items-center mt-1">
                {props.errors && props.errors.pickup_address_id ? (
                  <p style={{ color: 'red', fontSize: '12px', margin: 0 }}>
                    {props.errors.pickup_address_id}
                  </p>
                ) : <span></span>}
                <a
                  href="/address-shiprocket"
                  onClick={(e) => {
                    e.preventDefault();
                    if (props.navigate) {
                      props.navigate('/address-shiprocket');
                    } else {
                      window.location.href = '/address-shiprocket';
                    }
                  }}
                  style={{ fontSize: '12px', color: '#0d6efd', textDecoration: 'none', fontWeight: '500' }}
                >
                  + Manage Pickup Addresses
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Descriptions Card */}
        <div style={cardStyle}>
          <h5 style={{ marginBottom: '25px', fontWeight: '600', color: '#333' }}>Product Description</h5>
          <div className="row g-4">
            <div className="col-md-12">
              <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>Short Description <span className="text-danger">*</span></label>
              <textarea
                className="form-control form-control-lg shadow-none"
                style={{ ...inputStyle, minHeight: '100px' }}
                rows={3}
                onChange={e => props.setAddProductData({ ...props.addProductData, short_description: e.target.value })}
              ></textarea>
              {props.errors && props.errors.short_description ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{props.errors.short_description}</p> : null}
            </div>

            <div className="col-md-12">
              <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>Long Description <span className="text-danger">*</span></label>
              <div style={{ border: '1px solid #dcdfe6', borderRadius: '10px', overflow: 'hidden' }}>
                <CKEditor
                  editor={ClassicEditor}
                  data="<p></p>"
                  onReady={editor => {
                    console.log('Editor is ready to use!', editor);
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    props.setAddProductData({ ...props.addProductData, long_description: data })
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Specifications & Key Features Card */}
        <div style={cardStyle}>
          <h5 style={{ marginBottom: '10px', fontWeight: '600', color: '#333' }}>Specifications & Key Features</h5>

          <div className="row g-4">
            <div className="col-md-12">
              <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>
                Key Features / Product Features <span className="fw-normal text-danger" style={{ fontSize: '13px' }}>(For Grocery & Daily Essentials give expiry dates, batch no etc)</span> <span className="text-danger">*</span>
              </label>
              <textarea
                className="form-control form-control-lg shadow-none"
                style={{ ...inputStyle, minHeight: '110px' }}
                rows={4}
                placeholder="Enter key features (For Grocery & Daily Essentials give expiry dates, batch no etc)"
                value={props.addProductData?.key_features || ''}
                onChange={e => props.setAddProductData({ ...props.addProductData, key_features: e.target.value })}
              ></textarea>
              {props.errors && props.errors.key_features ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{props.errors.key_features}</p> : null}
            </div>

            <div className="col-md-12">
              <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>
                Product Specifications <span className="text-danger">*</span>
              </label>
              <textarea
                className="form-control form-control-lg shadow-none"
                style={{ ...inputStyle, minHeight: '120px' }}
                rows={5}
                value={props.addProductData?.specifications || ''}
                onChange={e => props.setAddProductData({ ...props.addProductData, specifications: e.target.value })}
              ></textarea>
              {props.errors && props.errors.specifications ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{props.errors.specifications}</p> : null}
            </div>
          </div>
        </div>

        {/* Manufacturing, Compliance & Origin Details Card */}
        <div style={cardStyle}>
          <h5 style={{ marginBottom: '10px', fontWeight: '600', color: '#333' }}>Compliance & Manufacturer Details</h5>

          <div className="row g-4">
            <div className="col-md-6">
              <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>
                Country of Origin – Country of Manufacture <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control form-control-lg shadow-none"
                style={inputStyle}
                value={props.addProductData?.country_of_origin !== undefined ? props.addProductData.country_of_origin : ''}
                onChange={e => props.setAddProductData({ ...props.addProductData, country_of_origin: e.target.value })}
              />
              {props.errors && props.errors.country_of_origin ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{props.errors.country_of_origin}</p> : null}
            </div>

            <div className="col-md-12">
              <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>
                Manufacturer Information – Name & Complete Address <span className="text-danger">*</span>
              </label>
              <textarea
                className="form-control form-control-lg shadow-none"
                style={{ ...inputStyle, minHeight: '90px' }}
                rows={3}
                value={props.addProductData?.manufacturer_info || ''}
                onChange={e => props.setAddProductData({ ...props.addProductData, manufacturer_info: e.target.value })}
              ></textarea>
              {props.errors && props.errors.manufacturer_info ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{props.errors.manufacturer_info}</p> : null}
            </div>

            <div className="col-md-12">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <label className="form-label text-muted fw-semibold mb-0" style={labelStyle}>
                  Packer Information – Name & Complete Address <span className="text-danger">*</span>
                </label>
                {props.addProductData?.manufacturer_info && (
                  <button
                    type="button"
                    className="btn btn-link btn-sm p-0 text-decoration-none"
                    style={{ fontSize: '13px' }}
                    onClick={() => {
                      props.setAddProductData({
                        ...props.addProductData,
                        packer_info: props.addProductData.manufacturer_info
                      });
                    }}
                  >
                    📋 Same as Manufacturer
                  </button>
                )}
              </div>
              <textarea
                className="form-control form-control-lg shadow-none"
                style={{ ...inputStyle, minHeight: '90px' }}
                rows={3}
                value={props.addProductData?.packer_info || ''}
                onChange={e => props.setAddProductData({ ...props.addProductData, packer_info: e.target.value })}
              ></textarea>
              {props.errors && props.errors.packer_info ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{props.errors.packer_info}</p> : null}
            </div>

            <div className="col-md-12">
              <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>
                Importer Information – Name & Complete Address <span className="text-muted fw-normal" style={{ fontSize: '13px' }}>(As Applicable)</span>
              </label>
              <textarea
                className="form-control form-control-lg shadow-none"
                style={{ ...inputStyle, minHeight: '90px' }}
                rows={3}
                placeholder="Name & complete address of importer (if imported)"
                value={props.addProductData?.importer_info || ''}
                onChange={e => props.setAddProductData({ ...props.addProductData, importer_info: e.target.value })}
              ></textarea>
              {props.errors && props.errors.importer_info ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{props.errors.importer_info}</p> : null}
            </div>
          </div>
        </div>

        {/* Configurations Card */}
        <div style={cardStyle}>
          <h5 style={{ marginBottom: '25px', fontWeight: '600', color: '#333' }}>Product Configurations</h5>
          <div className="row g-4">
            {/* Multiple Sizes Selection */}
            <div className='col-md-12'>
              <label className="form-label text-muted fw-semibold mb-3 d-block" style={labelStyle}>Do you have multiple sizes for this product? <span className="text-danger">*</span></label>
              <div className="d-flex gap-4">
                <div className="form-check" style={{ fontSize: '16px' }}>
                  <input className="form-check-input" type="radio" value="2" name="size" id="sizeYes" checked={props.sizeOption == '2'} onChange={(e) => props.onchangeSizeOption(e.currentTarget.value)} style={{ width: '1.2em', height: '1.2em', cursor: 'pointer' }} />
                  <label className="form-check-label ms-2" htmlFor="sizeYes" style={{ cursor: 'pointer', marginTop: '2px' }}>Yes</label>
                </div>
                <div className="form-check" style={{ fontSize: '16px' }}>
                  <input className="form-check-input" type="radio" value="1" name="size" id="sizeNo" checked={props.sizeOption == '1'} onChange={(e) => props.onchangeSizeOption(e.currentTarget.value)} style={{ width: '1.2em', height: '1.2em', cursor: 'pointer' }} />
                  <label className="form-check-label ms-2" htmlFor="sizeNo" style={{ cursor: 'pointer', marginTop: '2px' }}>No</label>
                </div>
              </div>
            </div>

            <div className='col-md-12 mt-4'>
              <label className="form-label text-muted fw-semibold mb-2 d-block" style={labelStyle}>Size Chart Image (Optional)</label>
              <input
                type="file"
                accept="image/*"
                className="form-control form-control-lg shadow-none"
                style={{ ...inputStyle, padding: '10px 15px', cursor: 'pointer' }}
                onChange={props.handleSizeChartChange}
              />
              {props.sizeChartPreview && (
                <div className="mt-2" style={{ padding: '5px', border: '1px solid #eaeaea', borderRadius: '12px', display: 'inline-block', backgroundColor: '#fff' }}>
                  <img src={props.sizeChartPreview} style={{ width: 120, height: 120, objectFit: 'contain', borderRadius: '8px' }} alt="Size Chart Preview" />
                  <button type="button" className="btn btn-danger btn-sm d-block w-100 mt-1" onClick={props.removeSizeChart}>Remove</button>
                </div>
              )}
            </div>

            <hr style={{ borderColor: '#eaeaea', margin: '30px 0' }} />

            {/* Product Image Selection */}
            <div className='col-md-12'>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <label className="form-label text-muted fw-semibold mb-0 d-block" style={labelStyle}>
                  Upload Product Images <span className="text-danger">*</span>
                </label>
                <div>
                  {props.selectedPhotos && props.selectedPhotos.length < 3 ? (
                    <span className="badge bg-danger text-white px-3 py-2" style={{ fontSize: '12px' }}>
                      ⚠️ {props.selectedPhotos.length} / 3 Photos Uploaded (At least 3 required)
                    </span>
                  ) : (
                    <span className="badge bg-success text-white px-3 py-2" style={{ fontSize: '12px' }}>
                      ✓ {props.selectedPhotos?.length || 0} Photos Uploaded (Minimum 3 met)
                    </span>
                  )}
                </div>
              </div>
              <small className="text-muted d-block mb-3" style={{ fontSize: '13px' }}>
                <span className="text-danger fw-bold">* At least 3 photos are required to create a product.</span> Select multiple files at once or add more. Max size 5MB per image. <strong className="text-primary">Recommended image size: 500x500 (small) to 800x800 (large) pixels for best display.</strong>
              </small>
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className='d-flex align-items-center gap-3'>
                    <input
                      type="file"
                      multiple
                      accept="image/*"
                      className={`form-control form-control-lg shadow-none ${props.errors && props.errors.image ? 'is-invalid' : ''}`}
                      style={{ ...inputStyle, padding: '10px 15px', cursor: 'pointer' }}
                      onChange={props.handleChange}
                    />
                  </div>
                  {props.errors && props.errors.image ? (
                    <p style={{ color: 'red', fontSize: '13px', marginTop: '6px', fontWeight: '500' }}>
                      ❌ {props.errors.image}
                    </p>
                  ) : props.selectedPhotos && props.selectedPhotos.length < 3 ? (
                    <p style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>
                      * Please select at least {3 - props.selectedPhotos.length} more photo(s).
                    </p>
                  ) : null}
                </div>
              </div>

              {/* Previews List */}
              {props.filePreviews && props.filePreviews.length > 0 ? (
                <div className="mt-3">
                  <h6 className="fw-semibold text-secondary mb-2" style={{ fontSize: '14px' }}>
                    Uploaded Photo Previews ({props.filePreviews.length}):
                  </h6>
                  <div className="d-flex flex-wrap gap-3">
                    {props.filePreviews.map((previewUrl, idx) => (
                      <div
                        key={idx}
                        style={{
                          position: 'relative',
                          padding: '4px',
                          border: idx === 0 ? '2px solid #0d6efd' : '1px solid #eaeaea',
                          borderRadius: '10px',
                          backgroundColor: '#fff'
                        }}
                      >
                        <img
                          src={previewUrl}
                          style={{ width: 110, height: 110, objectFit: 'cover', borderRadius: '8px' }}
                          alt={`Product Preview ${idx + 1}`}
                        />
                        {idx === 0 && (
                          <span
                            className="badge bg-primary position-absolute top-0 start-0 m-1"
                            style={{ fontSize: '10px' }}
                          >
                            Main Photo
                          </span>
                        )}
                        <button
                          type="button"
                          className="btn btn-danger btn-sm position-absolute top-0 end-0 m-1 rounded-circle p-0 d-flex align-items-center justify-content-center"
                          style={{ width: '22px', height: '22px', fontSize: '14px', fontWeight: 'bold' }}
                          onClick={() => props.handleRemovePhoto && props.handleRemovePhoto(idx)}
                          title="Remove photo"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              ) : props.filePreview && props.filePreview.image ? (
                <div className="mt-3">
                  <div style={{ padding: '5px', border: '1px solid #eaeaea', borderRadius: '12px', display: 'inline-block', backgroundColor: '#fff' }}>
                    <img
                      src={props.filePreview.image}
                      style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: '8px' }}
                      alt="Product Preview"
                    />
                  </div>
                </div>
              ) : null}
            </div>

            <hr style={{ borderColor: '#eaeaea', margin: '30px 0' }} />

            {/* Product policies */}
            <div className='col-md-12'>
              <label className="form-label text-muted fw-semibold mb-3 d-block" style={labelStyle}>Any Cancellation Policy?</label>
              <div className="d-flex gap-4 mb-3">
                <div className="form-check" style={{ fontSize: '16px' }}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="cancelPolicyRadio"
                    id="cancelPolicyNo"
                    value="2"
                    checked={props.addProductData && props.addProductData.is_cancel_policy !== "1"}
                    onChange={() => props.setAddProductData({
                      ...props.addProductData,
                      is_cancel_policy: "2",
                      cancel_policy_id: "",
                      cancel_policy_details: ""
                    })}
                    style={{ width: '1.2em', height: '1.2em', cursor: 'pointer' }}
                  />
                  <label className="form-check-label ms-2" htmlFor="cancelPolicyNo" style={{ cursor: 'pointer', marginTop: '2px' }}>No</label>
                </div>
                <div className="form-check" style={{ fontSize: '16px' }}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="cancelPolicyRadio"
                    id="cancelPolicyYes"
                    value="1"
                    checked={props.addProductData && props.addProductData.is_cancel_policy === "1"}
                    onChange={() => props.setAddProductData({
                      ...props.addProductData,
                      is_cancel_policy: "1"
                    })}
                    style={{ width: '1.2em', height: '1.2em', cursor: 'pointer' }}
                  />
                  <label className="form-check-label ms-2" htmlFor="cancelPolicyYes" style={{ cursor: 'pointer', marginTop: '2px' }}>Yes</label>
                </div>
              </div>

              {props.addProductData && props.addProductData.is_cancel_policy === '1' && (
                <div className="row g-4 mb-4 p-4 mt-2" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px', border: '1px solid #eaeaea', marginTop: '20px' }}>
                  <div className="col-md-6">
                    <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>Select Cancellation Policy</label>
                    <select
                      className="form-select form-select-lg shadow-none"
                      style={{ ...inputStyle, cursor: 'pointer' }}
                      value={props.addProductData?.cancel_policy_id || ''}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const selectedPolicy = props.cancelPolicyList && props.cancelPolicyList.find(p => p.id == selectedId);
                        props.setAddProductData({
                          ...props.addProductData,
                          cancel_policy_id: selectedId,
                          cancel_policy_details: selectedPolicy ? selectedPolicy.policy : ''
                        });
                      }}
                    >
                      <option value="">Select Cancellation Policy (From List)</option>
                      {props.cancelPolicyList && props.cancelPolicyList.map((item, index) => (
                        <option key={index} value={item.id}>{item.type || item.policy}</option>
                      ))}
                    </select>
                  </div>
                  {props.addProductData?.cancel_policy_id && (
                    <div className="col-md-12">
                      <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>Cancellation Policy Details</label>
                      <textarea
                        className="form-control form-control-lg shadow-none"
                        style={{ ...inputStyle, minHeight: '120px', backgroundColor: '#e9ecef', cursor: 'not-allowed' }}
                        rows={3}
                        value={props.addProductData?.cancel_policy_details || ''}
                        placeholder="Enter detailed cancellation policy..."
                        readOnly
                      ></textarea>
                    </div>
                  )}
                </div>
              )}

              <label className="form-label text-muted fw-semibold mb-3 d-block mt-4 pt-2" style={labelStyle}>Any Return Policy?</label>
              <div className="d-flex gap-4 mb-3">
                <div className="form-check" style={{ fontSize: '16px' }}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="policyRadio"
                    id="policyNo"
                    value="2"
                    checked={props.addProductData && props.addProductData.is_policy !== "1"}
                    onChange={() => props.setAddProductData({
                      ...props.addProductData,
                      is_policy: "2",
                      return_day: "0",
                      return_policy: NO_RETURN_POLICY_TEXT,
                      return_policy_id: ""
                    })}
                    style={{ width: '1.2em', height: '1.2em', cursor: 'pointer' }}
                  />
                  <label className="form-check-label ms-2" htmlFor="policyNo" style={{ cursor: 'pointer', marginTop: '2px' }}>No</label>
                </div>
                <div className="form-check" style={{ fontSize: '16px' }}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="policyRadio"
                    id="policyYes"
                    value="1"
                    checked={props.addProductData && props.addProductData.is_policy == "1"}
                    onChange={() => props.setAddProductData({
                      ...props.addProductData,
                      is_policy: "1",
                      return_day: "",
                      return_policy: "",
                      return_policy_id: ""
                    })}
                    style={{ width: '1.2em', height: '1.2em', cursor: 'pointer' }}
                  />
                  <label className="form-check-label ms-2" htmlFor="policyYes" style={{ cursor: 'pointer', marginTop: '2px' }}>Yes</label>
                </div>
              </div>

              {props.addProductData && props.addProductData.is_policy !== '1' && (
                <div className="p-3 mb-4 mt-3" style={{ backgroundColor: '#fff9f9', borderRadius: '12px', border: '1px solid #fed7d7', marginTop: '20px' }}>
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="badge" style={{ backgroundColor: '#ffebee', color: '#c62828', fontSize: '13px', padding: '6px 12px', borderRadius: '6px' }}>
                      Standard Non-Returnable Policy (Auto-Applied)
                    </span>
                    <small className="text-muted fw-semibold">Return Window: 0 Days</small>
                  </div>
                  <div style={{ fontSize: '13px', color: '#4b5563', whiteSpace: 'pre-line', lineHeight: '1.6', backgroundColor: '#fff', padding: '12px', borderRadius: '8px', border: '1px solid #fecaca' }}>
                    {props.addProductData?.return_policy || NO_RETURN_POLICY_TEXT}
                  </div>
                  <small className="text-muted d-block mt-2" style={{ fontSize: '12px' }}>
                    ℹ️ By selecting <strong>No</strong>, these standard terms are automatically accepted and will be displayed to buyers on the product page.
                  </small>
                </div>
              )}

              {props.addProductData && props.addProductData.is_policy == '1' && (
                <div className="row g-4 p-4 mt-2" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px', border: '1px solid #eaeaea', marginTop: '20px' }}>
                  <div className="col-md-6">
                    <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>Select Return Policy</label>
                    <select
                      className="form-select form-select-lg shadow-none"
                      style={{ ...inputStyle, cursor: 'pointer' }}
                      value={props.addProductData?.return_policy_id || ''}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const selectedPolicy = props.policyList && props.policyList.find(p => p.id == selectedId);
                        if (selectedPolicy) {
                          props.setAddProductData({
                            ...props.addProductData,
                            return_policy_id: selectedId,
                            return_day: selectedPolicy.return_policy_days ? String(selectedPolicy.return_policy_days) : props.addProductData?.return_day || '',
                            return_policy: selectedPolicy.return_policy || props.addProductData?.return_policy || ''
                          });
                        } else {
                          props.setAddProductData({
                            ...props.addProductData,
                            return_policy_id: selectedId
                          });
                        }
                      }}
                    >
                      <option value="">Select Return Policy (From List)</option>
                      {props.policyList && props.policyList.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.type || item.return_policy} {item.return_policy_days ? `(${item.return_policy_days} Days)` : ''}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>Return Duration (Days)</label>
                    <input
                      type="text"
                      className="form-control form-control-lg shadow-none"
                      style={{ ...inputStyle, backgroundColor: '#e9ecef', cursor: 'not-allowed' }}
                      value={props.addProductData?.return_day || ''}
                      placeholder="e.g. 7"
                      readOnly
                      onChange={e => props.setAddProductData({ ...props.addProductData, return_day: e.target.value })}
                    />
                    {props.errors && props.errors.return_day ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{props.errors.return_day}</p> : null}
                  </div>
                  <div className="col-md-12">
                    <label className="form-label text-muted fw-semibold mb-2" style={labelStyle}>Return Policy Details</label>
                    <textarea className="form-control form-control-lg shadow-none" style={{ ...inputStyle, minHeight: '120px', backgroundColor: '#e9ecef', cursor: 'not-allowed' }} rows={5}
                      value={props.addProductData?.return_policy || ''}
                      placeholder="Enter detailed return policy..."
                      readOnly
                    ></textarea>
                    {props.errors && props.errors.return_policy ? <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>{props.errors.return_policy}</p> : null}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>

      {/* Footer Button */}

    </div>
  );
};

export default ProductInformation;